import {
  getStore,
  getBlackoutDates,
  getHQStore,
  getStoreWithName,
  getPayTableConfig,
  getStoreWallet,
  getProductStatus,
} from "../../../api/services/storeService";
import { logger } from "../../../api/Logger";
import router from "../../../router";
import { getMessageTemplates } from "../../../api/services/MassageTemplateService.js";
import {
  defaultMobileColors,
  defaultDesktopColors,
  newUiColors,
} from "../../../api/constants/colors";
import { isStoreSelectionAtCheckout } from "../../../api/helpers/commonHelpers";
import { DetectMobile } from "../../../mixins/detectmobile";
import { DetectBrand } from "../../../mixins/brandDetector";
import { orderTypeHelper } from "../../../api/helpers/orderTypeHelper";
import { piplineConfigs } from "../../../mixins/piplineConfigs";
import { auth } from "../../../server";
import {
  getCurrentDate,
  IsStoreOpenAtTime,
} from "../../../api/helpers/datetimeHelper";
import { AppConfig } from "../../../../AppConfig";
import EventBus from "../../../event-bus";
import { normalizeQueryParams } from "../../../api/helpers/uiHelper.js";

export default {
  state: {
    storeDoc: null,
    showAlert: false,
    alertPayload: {
      title: null,
      body: null,
    },
    popoup: null,
    storeSelectionAtCheckout: false,
    selectedSubCompany: null,
    ViewConfig: {
      LogIn: false,
      PickUp: false,
      Delivery: false,
      DeliverToRoom: false,
      EatIn: false,
      HideAddressOnPickup: false,
      HideTrackingOrderForGuest: false,
      ImageCenterMode: false,
      UiColours: {
        Mobile: {},
        Desktop: {},
      },
    },
    selectedCompanyViewConfig: {
      PickUp: false,
      Delivery: false,
      DeliverToRoom: false,
      EatIn: false,
    },
    storeLoaded: false,
    isGift: false,
    HQDoc: null,
    ThankYouMsg: "",
    HQStore: null,
    MessageTemplates: {},
    availableLocales: [],
    selectedLocale: null,
    orderHistoryDic: [],
    mobileEmbededReturnUrl: "",
    isInCheckout: false,
    dineInDigitalDisplay: false,
    orderTypeModal: false,
    payTable: false,
    storeWallet: null,
    productStatuses: {},
    displayBill: false,
    tableNumberChanged: false,
  },
  mutations: {
    setProductStatus(state, payload) {
      state.productStatuses = payload;
    },
    setMobileEmbededReturnUrl(state, payload) {
      state.mobileEmbededReturnUrl = payload;
    },
    setIsInCkeckout(state, payload) {
      state.isInCheckout = payload;
    },
    setDineInDigitalDisplay(state, payload) {
      state.dineInDigitalDisplay = payload;
    },
    setSelectedSubCompany(state, payload) {
      state.selectedSubCompany = payload;
      var config = state.selectedSubCompany
        ? state.selectedSubCompany.ViewComponentConfigs
        : {};
      if (!config) config = {};
      const enableNewUI =
        piplineConfigs.methods.isNewUI() || config.IsNewUi || false;

      var settings = {
        PickUp: config.PickUp || false,
        Delivery: config.Delivery || false,
        DeliverToRoom: config.DeliverToRoom || false,
        ChargeToRoomRadio: config.ChargeToRoomRadio === false ? false : true,
        EnableCashOnPickup: config.EnableCashOnPickup || false,
        EnableAlipayPayment: config.EnableAlipayPayment || false,
        EnableConfetti: config.EnableConfetti || false,
        EnableWechatPayment: config.EnableWechatPayment || false,
        EnableApplePayment: config.ApplePayEnabled || false,
        EnableGooglePayment: config.GooglePayEnabled || false,
        EatIn: config.EatIn || false,
        PayLaterOnly: config.PayLaterOnly || false,
        EatInPayLater: config.EatInPayLater || false,
        CashOnDelivery: config.CashOnDelivery || false,
        IsNewUi: enableNewUI,
        EnableMobileAuthentication: config.EnableMobileAuthentication,
        TipsEnabled: config.TipsEnabled || false,
        ShareCart: config.ShareCart || false,
        SharedCartSingleOrder: config.SharedCartSingleOrder || false,
      };
      state.selectedCompanyViewConfig = { ...settings };
    },
    setShowAlert(state, payload) {
      state.showAlert = payload;
    },
    setAlertPayload(state, payload) {
      state.alertPayload = payload;
    },
    setPopup(state, payload) {
      state.popoup = payload;
    },
    setCurrentStoreDoc(state, payload) {
      if (payload) {
        state.storeDoc = payload;
        var config = state.storeDoc.ViewComponentConfigs;
        if (isStoreSelectionAtCheckout(payload)) {
          state.storeSelectionAtCheckout = true;
        } else {
          state.storeSelectionAtCheckout = false;
        }
        const stripeKey = state && state.storeDoc && state.storeDoc.PaymentConfigEnvironment === 'Sandbox'
        ? AppConfig.stripeTestToken
        : AppConfig.stripeToken;
        EventBus.$emit('update-stripe-config', stripeKey);
      }
      InitViewConfig(state, config || {});
    },
    setHQDoc(state, payload) {
      state.HQDoc = payload;
    },
    setStoreWallet(state, payload) {
      state.storeWallet = payload;
    },
    setHQStore(state, payload) {
      state.HQStore = payload;
    },
    setStoreLoaded(state) {
      state.storeLoaded = true;
    },
    setStoreLoading(state) {
      state.storeLoaded = false;
    },
    setIsGift(state, payload) {
      state.isGift = payload;
    },
    addUserOrderHistory(state, payload) {
      if (state.orderHistoryDic.length > 100) state.orderHistoryDic.shift(); //Remove first element
      state.orderHistoryDic.push({
        key: state.storeDoc.ID,
        value: payload,
      });
    },
    addMessageTemplates(state, payload) {
      state.MessageTemplates[payload.id] = payload.value;
      if (payload.id.trim() === "OrderSuccessfulScreen") {
        state.ThankYouMsg = payload.value;
      }
    },
    clearMessageTemplates(state) {
      state.MessageTemplates = {};
      state.ThankYouMsg = "";
    },
    setAvailableLocales(state, payload) {
      state.availableLocales = payload;
      if (!state.selectedLocale) state.selectedLocale = payload[0];
    },
    setCurrentLocale(state, payload) {
      state.selectedLocale = payload;
    },
    //toggle order type modal
    setOrderTypeModalDisplay(state, value) {
      state.orderTypeModal = value;
    },
    // toggle pay at table enabled
    setPayTableEnabled(state, value) {
      state.payTable = value;
    },
    SET_DISPLAY_BILL(state, value) {
      state.displayBill = value;
    },
    setTableNumberChanged(state, value) {
      state.tableNumberChanged = value;
    },
  },
  actions: {
    async initStore({ commit, dispatch }, payload) {
      getStore(payload.storeId).onSnapshot(
        async function (doc) {
          if (doc.exists) {
            let storeData = doc.data();
            try {
              if (DetectBrand.methods.isBranded()) {
                let amendmentDoc = await getBlackoutDates(
                  payload.storeId
                ).get();
                if (amendmentDoc.exists) {
                  let amendment = amendmentDoc.data();
                  storeData.BlackoutDates = amendment.BlackoutDates;
                }
              }
              // else {
              //   if (router.currentRoute.name.indexOf("gift") == -1) {
              //     try {
              //       let validationRes = await handleIsValidInstance(
              //         storeData.HQCompanyID
              //       );
              //       if (!validationRes.IsValid) {
              //         router.push({
              //           name: "notFoundPage",
              //           query: { message: validationRes.Status.Message },
              //         });
              //       }
              //     } catch (error) {
              //       console.log(error);
              //     }
              //   }
              // }
            } catch (error) {
              logger.log(error);
            } finally {
              commit("setCurrentStoreDoc", storeData);
              commit("setShowOverlay", false);
              await dispatch("initHQDoc", storeData.HQCompanyID);
              dispatch("initPriceTriggers", payload.storeId);
              dispatch("validateLogin");
            }
            if (payload.callback) {
              payload.callback();
            }
          } else {
            router.replace("/pagenotfound");
          }
        },
        function (reason) {
          logger.log(
            reason.code,
            reason.message,
            router.currentRoute.fullPath,
            logger.LogType.Error
          );
          router.replace("/GeneralError");
        }
      );

      dispatch("initProductStatuses", payload.storeId);
    },
    initStoreWithName({ commit }, payload) {
      getStoreWithName(payload).onSnapshot(
        async function (doc) {
          if (doc.docs.length) {
            const storeId = doc.docs[0].id;
            let storeDoc = doc.docs[0].data();

            try {
              if (DetectBrand.methods.isBranded()) {
                let amendmentDoc = await getBlackoutDates(storeId).get();
                if (amendmentDoc.exists) {
                  let amendment = amendmentDoc.data();
                  storeDoc.BlackoutDates = amendment.BlackoutDates;
                }
              }
            } catch (error) {
              logger.log(error);
            } finally {
              commit("setCurrentStoreDoc", storeDoc);
            }
          } else {
            router.replace("/notFoundPage");
          }
        },
        function (reason) {
          logger.log(
            reason.code,
            reason.message,
            router.currentRoute.fullPath,
            logger.LogType.Error
          );
          router.replace("/GeneralError");
        }
      );
    },
    initProductStatuses({ commit }, storeId) {
      getProductStatus(storeId).onSnapshot(function (snapshot) {
        let statuses = {};
        if (!snapshot.empty) {
          snapshot.docs.forEach((doc) => {
            const p = doc.data();
            statuses[doc.id] = p.Status;
          });
          commit("setProductStatus", statuses);
        }
      });
    },
    initStoreWallet({ commit }, storeId) {
      getStoreWallet(storeId).onSnapshot(
        async function (doc) {
          let storeWallet = null;
          if (doc.exists) {
            storeWallet = doc.data();
          }
          commit("setStoreWallet", storeWallet);  
        },
        function (reason) {
          logger.log(
            reason.code,
            reason.message,
            router.currentRoute.fullPath,
            logger.LogType.Error
          );
        }
      );
    },
    async selectSubCompany({ commit, getters }, payload) {
      var storeDoc = null;
      let amendment = null;
      let storeId = payload || (getters.getSelectedSubCompany || {}).ID;
      if (storeId) {
        let res = await getStore(storeId).get();
        storeDoc = res.data();
        if (DetectBrand.methods.isBranded()) {
          try {
            let amendmentDoc = await getBlackoutDates(storeId).get();
            amendment = amendmentDoc.data();
            storeDoc.BlackoutDates = amendment.BlackoutDates;
          } catch (error) {
            logger.log(error);
          }
        }
      }

      commit("setSelectedSubCompany", storeDoc);
    },
    async initHQDoc({ commit, getters }, hqId) {
      let hq = await getHQStore(hqId);
      try {
        if (DetectBrand.methods.isBranded() && hq && hq.ID) {
          let amendmentDoc = await getBlackoutDates(hq.ID).get();
          if (amendmentDoc.exists) {
            let amendment = amendmentDoc.data();
            hq.BlackoutDates = amendment.BlackoutDates;
          }
        }
      } catch (error) {
        logger.log(error);
      } finally {
        commit("setHQDoc", hq);
        EventBus.$emit('update-script', ({ hq: hq, store: getters.selectedCompany }));
      }
    },
    initMessageTemplates({ commit }, payload) {
      commit("clearMessageTemplates");
      getMessageTemplates(payload).onSnapshot(
        function (data) {
          if (data.docs) {
            data.docs.forEach(function (doc) {
              commit("addMessageTemplates", {
                id: doc.id.trim(),
                value: doc.data().template,
              });
            });
          }
        },
        function (reason) {
          logger.log(
            reason.code,
            reason.message,
            router.currentRoute.fullPath,
            logger.LogType.Error
          );
        }
      );
    },
    initPayTable({ commit }, payload) {
      getPayTableConfig(payload).onSnapshot(function (doc) {
        if (doc.exists) {
          if (doc.data().GeneralConfiguration) {
            const integrateWithOnlineOrdering = doc.data().GeneralConfiguration.integrateWithOnlineOrdering ? true : false;
            commit("setPayTableEnabled", integrateWithOnlineOrdering);
          }
        } else {
          commit("setPayTableEnabled", false);
        }
      });
    },
    raiseAlert({ commit }, payload) {
      commit("setAlertPayload", payload);
      commit("setShowAlert", true);
    },
    validateLogin({ dispatch, getters }) {
      if (
        getters.viewConfig &&
        getters.viewConfig.LogIn === false &&
        auth.currentUser
      ) {
        dispatch("logout");
      }
    },
    setDisplayBill({ commit, getters }, payload) {
      commit("SET_DISPLAY_BILL", payload && getters.showSharedCart);
    },
  },
  getters: {
    getStripeKey(state) {
      const stripeKey = state && state.storeDoc && state.storeDoc.PaymentConfigEnvironment === 'Sandbox'
        ? AppConfig.stripeTestToken
        : AppConfig.stripeToken;
      return stripeKey
    },
    productStatuses(state) {
      return state.productStatuses;
    },
    currencySign(state) {
      if (state && state.storeDoc && state.storeDoc.CurrencyLocaleName) {
        const locale = state.storeDoc.CurrencyLocaleName.toLowerCase();
        return locale == "id-id"
          ? {
              symbol: "Rp ",
              precision: 0,
            }
          : "$";
      } else {
        return "$";
      }
    },
    storeSelectionAtCheckoutMode(state) {
      return state.storeSelectionAtCheckout;
    },
    getShowAlert(state) {
      return state.showAlert;
    },
    getAlertPayload(state) {
      return state.alertPayload;
    },
    getPopup(state) {
      return state.popoup;
    },
    getSelectedSubCompany(state) {
      return state.selectedSubCompany;
    },
    selectedCompany(state) {
      if (state.storeSelectionAtCheckout && state.isInCheckout) {
        return state.selectedSubCompany || {};
      } else return state.storeDoc || {};
    },
    selectedCompanyViewConfig(state) {
      if (state.storeSelectionAtCheckout && state.isInCheckout) {
        return state.selectedCompanyViewConfig || {};
      } else return state.ViewConfig || {};
    },
    isDigitalDisplay(state, getters) {
      return (
        (!getters.selectedCompanyViewConfig.Delivery &&
          !getters.selectedCompanyViewConfig.PickUp &&
          !getters.selectedCompanyViewConfig.DeliverToRoom &&
          !getters.selectedCompanyViewConfig.EatIn) ||
        state.dineInDigitalDisplay & !getters.selectedCompanyViewConfig.EatIn
      );
    },
    getMobileEmbededReturnUrl(state) {
      return state.mobileEmbededReturnUrl;
    },
    selectedLocale(state) {
      return state.selectedLocale;
    },
    getAvailableLanguages(state) {
      return state.availableLocales.map((m) => {
        return {
          locale: m,
          name: m == "en" ? "English" : "中文",
        };
      });
    },
    getMessageTemplates(state) {
      return state.MessageTemplates;
    },
    getThankYouMessage(state) {
      return (
        state.ThankYouMsg ||
        "A request has been sent. Please check your email to see the status of your order."
      );
    },
    currentStoreDoc(state) {
      return state.storeDoc;
    },
    viewConfig(state, getters) {
      let hqConfig;
      if (getters.hqDoc) {
        hqConfig = getters.hqDoc.ViewComponentConfigs;
      }
      if (
        DetectBrand.methods.isBranded() &&
        getters.selectedCompany.ReadHQOOConfig &&
        getters.hqDoc
      ) {
        var uiColours = hqConfig.UiColours;
        var colors = initTheme(state, hqConfig, uiColours);
        return {
          ...state.ViewConfig,
          ...{
            UiColours: { ...colors },
            ShowNotes: hqConfig.ShowNotes || false,
            ShowNotesForItem: hqConfig.ShowNotesForItem || false,
            LogIn: DetectBrand.methods.isBranded() || hqConfig.LogIn || false,
            PickUp: hqConfig.PickUp || false,
            Delivery: hqConfig.Delivery || false,
            DeliverToRoom: hqConfig.DeliverToRoom || false,
            ChargeToRoomRadio:
              hqConfig.ChargeToRoomRadio === false ? false : true,
            EnableCashOnPickup: hqConfig.EnableCashOnPickup || false,
            EnableAlipayPayment: hqConfig.EnableAlipayPayment || false,
            EnableConfetti: hqConfig.EnableConfetti || false,
            EnableWechatPayment: hqConfig.EnableWechatPayment || false,
            EnableApplePayment: hqConfig.ApplePayEnabled || false,
            EnableGooglePayment: hqConfig.GooglePayEnabled || false,
            EatIn: hqConfig.EatIn || false,
            HideAddressOnPickup: hqConfig.HideAddressOnPickup || false,
            HideTrackingOrderForGuest:
              hqConfig.HideTrackingOrderForGuest || false,
            ImageCenterMode: hqConfig.ImageCenterMode || false,
            FacebookLogin: hqConfig.FacebookLogin != false,
            GoogleLogin: hqConfig.GoogleLogin != false,
            IsHideCheckboxMarketing: hqConfig.IsHideCheckboxMarketing || false,
            PayLaterOnly: hqConfig.PayLaterOnly || false,
            EatInPayLater: hqConfig.EatInPayLater || false,
          },
        };
      } else {
        return {
          ...state.ViewConfig,
          LogIn:
            DetectBrand.methods.isBranded() ||
            (hqConfig && hqConfig.LogIn
              ? hqConfig.LogIn
              : state.ViewConfig.LogIn),
        };
      }
    },
    storeLoaded(state) {
      return state.storeLoaded;
    },
    isGift(state) {
      return state.isGift;
    },
    hqDoc(state) {
      return state.HQDoc;
    },
    HQStore(state) {
      return state.HQStore;
    },
    getRecentOrder: (state) => (productId) => {
      for (var i = state.orderHistoryDic.length - 1; i >= 0; i--) {
        if (state.orderHistoryDic[i].key == productId) {
          return state.orderHistoryDic[i].value;
        }
      }
    },
    getRecentOrders(state, payload) {
      var orders = [];
      for (var i = 0 - 1; i < state.orderHistoryDic.length; i++) {
        if (state.orderHistoryDic[i].key == payload) {
          orders.push(state.orderHistoryDic[i].value);
        }
      }
      return orders;
    },
    getApplyMultiCoupon() {
      //TODO: this part must be get from firebase.
      return false;
    },
    isInCheckout(state) {
      return state.isInCheckout;
    },
    deliveryTimeSlots(state, getters) {
      let deliveryZones = getters.hqDoc
        ? getters.hqDoc.DeliveryZones
        : getters.selectedCompany.DeliveryZones;
      if (
        getters.selectedCompany &&
        getters.selectedCompany.DeliveryAreaPostCodes &&
        getters.selectedCompany.DeliveryAreas &&
        getters.deliveryAddress &&
        getters.deliveryAddress.PostalCode &&
        getters.selectedCompany.DeliveryAreas.some(
          (s) =>
            s.PostcodeFrom <= getters.deliveryAddress.PostalCode &&
            s.PostcodeTo >= getters.deliveryAddress.PostalCode
        )
      ) {
        var timeSlots = getters.selectedCompany.DeliveryAreas.find(
          (p) =>
            p.PostcodeFrom <= getters.deliveryAddress.PostalCode &&
            p.PostcodeTo >= getters.deliveryAddress.PostalCode
        ).TimeSlots;
        return timeSlots ? timeSlots : null;
      } else if (
        getters.selectedCompany &&
        getters.selectedCompany.DeliveryAreaZones &&
        deliveryZones &&
        getters.getSelectedDeliveryZone &&
        getters.getSelectedDeliveryZone.zoneName &&
        deliveryZones.some(
          (s) => s.ZoneName == getters.getSelectedDeliveryZone.zoneName
        )
      ) {
        var zoneTimeSlots = deliveryZones.find(
          (s) => s.ZoneName == getters.getSelectedDeliveryZone.zoneName
        ).ZoneTimeSlots;
        return zoneTimeSlots ? zoneTimeSlots : null;
      }
      return null;
    },
    isDeliveryTimeSlotsEnable(state, getters) {
      let deliveryZones = getters.hqDoc
        ? getters.hqDoc.DeliveryZones
        : getters.selectedCompany.DeliveryZones;
      if (
        getters.deliveryAddress &&
        getters.deliveryAddress.PostalCode &&
        getters.selectedCompany &&
        getters.selectedCompany.DeliveryAreaPostCodes &&
        getters.selectedCompany.DeliveryAreas
      ) {
        return getters.selectedCompany.DeliveryAreas.some(
          (s) =>
            getters.deliveryAddress.PostalCode >= +s.PostcodeFrom &&
            getters.deliveryAddress.PostalCode <= +s.PostcodeTo &&
            s.TimeSlots &&
            s.TimeSlots.length > 0
        );
      } else if (
        getters.getSelectedDeliveryZone &&
        getters.selectedCompany &&
        getters.selectedCompany.DeliveryAreaZones &&
        deliveryZones
      ) {
        let zone = deliveryZones.find(
          (s) => s.ZoneName == getters.getSelectedDeliveryZone.zoneName
        );
        return zone && zone.ZoneTimeSlots && zone.ZoneTimeSlots.length > 0;
      }
      return false;
    },

    // check if modal is visible
    getOrderTypeModalDisplay: (state) => {
      return state.orderTypeModal;
    },
    showNewUi(state) {
      return state.ViewConfig.IsNewUi;
    },
    payTableEnabled(state) {
      return state.payTable;
    },
    showSharedCart: (state) => {
      return state.ViewConfig.ShareCart && orderTypeHelper.isDineIn();
    },
    getLivenBranchID(state) {
      return state.ViewConfig.LivenBranchID;
    },
    getStoreWalletDoc(state) {
      return state.storeWallet;
    },
    getStoreColor(state) {
      if (
        state.storeDoc &&
        state.storeDoc.ThemeSettings &&
        state.storeDoc.ThemeSettings.Colours &&
        state.storeDoc.ThemeSettings.Colours.IntroBackground
      ) {
        return state.storeDoc.ThemeSettings.Colours.IntroBackground;
      }

      //default color
      return "#3994ff";
    },
    showGuestCount: (state) => {
      return (
        state.storeDoc &&
        state.storeDoc.EnableGuestCount &&
        orderTypeHelper.isDineIn() &&
        !normalizeQueryParams(router.currentRoute.query)['guestcount'] &&
        state.tableNumberChanged
      );
    },
    getGuestsPerTableMax: (state) => {
      return state.storeDoc && state.storeDoc.GuestsPerTableMax
        ? state.storeDoc.GuestsPerTableMax
        : 9;
    },
    getGuestsPerTableMin: (state) => {
      return state.storeDoc && state.storeDoc.GuestsPerTableMin
        ? state.storeDoc.GuestsPerTableMin
        : 1;
    },
    storeClosed(state, getters) {
      const store = getters.selectedCompany;
      var now = getCurrentDate(store.TimezoneIanaFormat);
      if (!store.EnablePreoderForPickup && !store.EnablePreoderForDelivery)
        now = now.plus({ minutes: store.OrderPreparationTime });

      const storeClosed =
        (!IsStoreOpenAtTime(
          store.BlackoutDates,
          store.OperatingHours,
          store.IsInOperation,
          now
        ) &&
          !(store.EnablePreoderForDelivery || store.EnablePreoderForPickup)) ||
        !store.IsInOperation;
      return storeClosed;
    },
    getLivenPay: (state, getters) => {
      return getters.getLivenBranchID && DetectMobile.methods.isMobile();
    },
    shouldDisplayBill: (state) => {
      return state.displayBill;
    },
    getSharedCartSingleOrder: (state) => {
      return state.ViewConfig.SharedCartSingleOrder;
    },
    paylaterSettings(state) {
      if (
        state.storeDoc &&
        state.storeDoc.ViewComponentConfigs &&
        state.storeDoc.ViewComponentConfigs.WastageSettings
      ) {
        const settings = state.storeDoc.ViewComponentConfigs.WastageSettings;
        const queryParams = normalizeQueryParams(router.currentRoute.query);
        return {
          Enabled:
            (settings.Enabled && queryParams['guestcount']) || false,
          HighFrequencyAlertTime: settings.HighFrequencyAlertTime || 0,
          MaxPax: settings.MaxPax || 0,
          WastageLimit: settings.WastageLimit || 0,
          MaximumQuantityLimit: settings.MaximumQuantityLimit || 0,
          Notifications: settings.Notifications || [],
        };
      } else {
        return {
          Enabled: false,
          HighFrequencyAlertTime: 0,
          MaxPax: 0,
          WastageLimit: 0,
          MaximumQuantityLimit: 0,
          Notifications: [],
        };
      }
    },
    payLaterNotifications(state, getters) {
      const settings = getters.paylaterSettings;
      const defaultSetting = { Enabled: false, Message: "" };
      const firstTimeAlert = (settings.Notifications || {}).FirstTimeAlert;
      const checkoutAlert = (settings.Notifications || {}).CheckoutAlert;
      const highFrequencyAlert = (settings.Notifications || {})
        .HighFrequencyAlert;
      const wasteAlert = (settings.Notifications || {}).WastageAlert;
      const duplicateItemsAlert = (settings.Notifications || {})
        .DuplicateItemsAlert;

      return {
        FirstTimeAlert: firstTimeAlert || defaultSetting,
        CheckoutAlert: checkoutAlert || defaultSetting,
        HighFrequncyAlert: highFrequencyAlert || defaultSetting,
        WastageAlert: wasteAlert || defaultSetting,
        DuplicateItemsAlert: duplicateItemsAlert || defaultSetting,
      };
    },
  },
};

function InitViewConfig(state, config) {
  let enableLogin = DetectBrand.methods.isBranded() || config.LogIn;
  const enableNewUI =
    piplineConfigs.methods.isNewUI() || config.IsNewUi || false;
  var settings = {
    ShowNotes: config.ShowNotes || false,
    ShowNotesForItem: config.ShowNotesForItem || false,
    LogIn: enableLogin,
    PickUp: config.PickUp || false,
    Delivery: config.Delivery || false,
    DeliverToRoom: config.DeliverToRoom || false,
    ChargeToRoomRadio: config.ChargeToRoomRadio === false ? false : true,
    EnableCashOnPickup: config.EnableCashOnPickup || false,
    EnableAlipayPayment: config.EnableAlipayPayment || false,
    EnableConfetti: config.EnableConfetti || false,
    EnableWechatPayment: config.EnableWechatPayment || false,
    EnableApplePayment: config.ApplePayEnabled || false,
    EnableGooglePayment: config.GooglePayEnabled || false,
    EatIn: config.EatIn || false,
    HideAddressOnPickup: config.HideAddressOnPickup || false,
    HideTrackingOrderForGuest: config.HideTrackingOrderForGuest || false,
    ImageCenterMode: config.ImageCenterMode || false,
    FacebookLogin: config.FacebookLogin != false,
    GoogleLogin: config.GoogleLogin != false,
    IsHideCheckboxMarketing: config.IsHideCheckboxMarketing || false,
    PayLaterOnly: config.PayLaterOnly || false,
    EatInPayLater: config.EatInPayLater || false,
    CashOnDelivery: config.CashOnDelivery || false,
    IsNewUi: enableNewUI,
    EnableMobileAuthentication: config.EnableMobileAuthentication,
    TipsEnabled: config.TipsEnabled || false,
    ShareCart: config.ShareCart || false,
    ViewStamp: config.ViewStamp || false,
    LivenBranchID: config.LivenBranchID || false,
    SharedCartSingleOrder: config.SharedCartSingleOrder || false,
  };
  if (!config.UiColours) {
    config.UiColours = {
      Mobile: {},
      Desktop: {},
    };
  }
  state.ViewConfig.UiColours = {
    ...state.ViewConfig.UiColours,
    ...initTheme(state, config),
  };
  state.ViewConfig = { ...state.ViewConfig, ...settings };
}
function initTheme(state, config) {
  var colors = { ...state.ViewConfig.UiColours };
  var mobileAgent = DetectMobile.methods.isMobile();

  if (mobileAgent) {
    config.UiColours.Mobile = config.UiColours.Mobile || {};
    var mobile = config.UiColours.Mobile;
    if (mobile) {
      if (config.IsNewUi) {
        colors.Mobile = {
          ButtonColour: mobile.ButtonColour || newUiColors.ButtonColour,
          ButtonText: mobile.ButtonText || newUiColors.ButtonText,
          CommonColor: mobile.CommonColour || newUiColors.CommonColor,
          MenuHighlight: mobile.MenuHighlight || newUiColors.MenuHighlight,
          MenuHighlightedText:
            mobile.MenuHighlightText || newUiColors.MenuHighlightedText,
          StatusPending: mobile.StatusPending || newUiColors.StatusPending,
          TitleBar: mobile.TitleBar || newUiColors.TitleBar,
          MenuBackground: mobile.MenuBackground || newUiColors.MenuBackground,
          MenuText: mobile.MenuText || newUiColors.MenuText,
          SplashScreenTextColor:
            mobile.HighlightTextColour || newUiColors.HighlightTextColour,
          CustomButtonColour:
            mobile.CustomButtonColour || newUiColors.CustomButtonColour,
        };
      } else {
        colors.Mobile = {
          ButtonColour: mobile.ButtonColour || defaultMobileColors.ButtonColour,
          ButtonText: mobile.ButtonText || defaultMobileColors.ButtonText,
          CommonColor: mobile.CommonColour || defaultMobileColors.CommonColor,
          MenuHighlight:
            mobile.MenuHighlight || defaultMobileColors.MenuHighlight,
          MenuHighlightedText:
            mobile.MenuHighlightText || defaultMobileColors.MenuHighlightedText,
          StatusPending:
            mobile.StatusPending || defaultMobileColors.StatusPending,
          TitleBar: mobile.TitleBar || defaultMobileColors.TitleBar,
          MenuBackground:
            mobile.MenuBackground || defaultMobileColors.MenuBackground,
          MenuText: mobile.MenuText || defaultMobileColors.MenuText,
          SplashScreenTextColor:
            mobile.HighlightTextColour ||
            defaultMobileColors.HighlightTextColour,
          CustomButtonColour:
            mobile.CustomButtonColour || defaultMobileColors.CustomButtonColour,
        };
      }
    }
  } else {
    config.UiColours.Desktop = config.UiColours.Desktop || {};
    var desktop = config.UiColours.Desktop;
    if (desktop) {
      if (config.IsNewUi) {
        colors.Desktop = {
          ButtonColour: desktop.ButtonColour || newUiColors.ButtonColour,
          ButtonText: desktop.ButtonText || newUiColors.ButtonText,
          CommonColor: desktop.CommonColour || newUiColors.CommonColor,
          MenuHighlight: desktop.MenuHighlight || newUiColors.MenuHighlight,
          MenuHighlightedText:
            desktop.MenuHighlightText || newUiColors.MenuHighlightedText,
          StatusPending: desktop.StatusPending || newUiColors.StatusPending,
          TitleBar: desktop.TitleBar || newUiColors.TitleBar,
          MenuBackground: desktop.MenuBackground || newUiColors.MenuBackground,
          MenuText: desktop.MenuText || newUiColors.MenuText,
          SplashScreenTextColor:
            desktop.HighlightTextColour || newUiColors.HighlightTextColour,
        };
      } else {
        colors.Desktop = {
          ButtonColour:
            desktop.ButtonColour || defaultDesktopColors.ButtonColour,
          ButtonText: desktop.ButtonText || defaultDesktopColors.ButtonText,
          CommonColor: desktop.CommonColour || defaultDesktopColors.CommonColor,
          MenuHighlight:
            desktop.MenuHighlight || defaultDesktopColors.MenuHighlight,
          MenuHighlightedText:
            desktop.MenuHighlightText ||
            defaultDesktopColors.MenuHighlightedText,
          StatusPending:
            desktop.StatusPending || defaultDesktopColors.StatusPending,
          TitleBar: desktop.TitleBar || defaultDesktopColors.TitleBar,
          MenuBackground:
            desktop.MenuBackground || defaultDesktopColors.MenuBackground,
          MenuText: desktop.MenuText || defaultDesktopColors.MenuText,
          SplashScreenTextColor:
            desktop.HighlightTextColour ||
            defaultDesktopColors.HighlightTextColour,
        };
      }
    }
  }
  return colors;
}
